export function setScenePosition(passedKey, options = {}) {
  const Scene = this.lookup('ComponentFrameCanvasTooltip')
  const key = passedKey || this.state?.value || this.text

  if (!options.visible || !key) {
    return Scene.setNodeStyles({
      opacity: '0',
      visibility: 'hidden'
    })
  }

  const type = this.call('getType', key)
  const value = this.getData(type)[key]
  const schema = this.getSchema(type)[key]

  if (
    !value ||
    !schema ||
    (Scene.data.key === schema.key && Scene.visibility === 'visible')
  ) {
    return Scene.setNodeStyles({
      opacity: '0',
      visibility: 'hidden'
    })
  }

  Scene.data.key = schema.key

  // eslint-disable-next-line init-declarations
  let transform
  if (options.position === 'bottom') {
    const position = `${this.node.getBoundingClientRect().left}px`
    const translate = `calc(${position} - 50%)`
    transform = `translate3d(${translate}, 0, 0)`
  } else if (options.position === 'mouse' && options.mouseEvent) {
    // Position relative to mouse cursor
    const x = options.mouseEvent.clientX //- 250
    const y = options.mouseEvent.clientY - 35
    transform = `translate3d(${x}px, ${y}px, 0)`
  } else {
    const rect = this.node.getBoundingClientRect()
    const tooltipNode = Scene.node

    const tooltipWidth = tooltipNode.offsetWidth
    const tooltipHeight = tooltipNode.offsetHeight

    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    let top = rect.top - 15
    let left = rect.left + rect.width / 2 - 50

    // Clamp left and top to keep tooltip within viewport
    left = Math.max(0, Math.min(left, viewportWidth - tooltipWidth - 35))
    top = Math.max(0, Math.min(top, viewportHeight - tooltipHeight - 35))

    const topPosition = `${top}px`
    const leftPosition = `${left}px`
    transform = `translate3d(${leftPosition}, ${topPosition}, 0px)`
  }

  Scene.setNodeStyles({
    opacity: '1',
    visibility: 'visible',
    transform
  })

  window.requestAnimationFrame(() => {
    const componentState = this.call('deepClone', { value, ...schema })
    Scene.state.set(componentState)
  })
}
